<template>
  <v-card>
    <v-form @submit.prevent="submit()" ref="form">
      <v-card-title>
        <div>
          <div class="headline">{{add ? 'Add' : 'Edit'}} Authorization Class</div>
          <div class="subheading">{{add ? '' : userAuthClassObj['name']}}</div>
        </div>
      </v-card-title>
      <v-container grid-list-lg class="pt-0">
        <v-layout wrap>
          <v-flex xs12 v-if="add">
            <v-text-field label="* Name" v-model="userAuthClassObj.name" :rules="nameRules"></v-text-field>
          </v-flex>
                        <!-- <v-flex xs12 sm4 v-for="(header) of allPossibleHeaders" :key="header.value" v-show="header.value != 'name'">
                            <v-switch
                            :disabled="userAuthClass.id == 1"
                            
                            :label="header.text"
                            v-model="userAuthClass[header.value]">
                            </v-switch>
          </v-flex> -->

          <v-flex xs12>
            <span class="subheading">Master files</span>
            <v-divider class="mt-2"></v-divider>
          </v-flex>
          <v-flex
            xs12
            sm6
            v-for="(header) of allPossibleHeaders.filter(item =>{ return item.group == 'master'})"
            :key="header.value"
            v-show="header.value != 'name'"
          >
            <v-switch
              :disabled="userAuthClassObj.id == 1"
              :label="header.text"
              v-model="userAuthClassObj[header.value]"
            ></v-switch>
          </v-flex>

          <v-flex xs12>
            <span class="subheading">Transactions</span>
            <v-divider class="mt-2"></v-divider>
          </v-flex>
          <v-flex
            xs12
            sm6
            v-for="(header) of allPossibleHeaders.filter(item =>{ return item.group == 'transaction'})"
            :key="header.value"
            v-show="header.value != 'name'"
          >
            <v-switch
              :disabled="userAuthClassObj.id == 1"
              :label="header.text"
              v-model="userAuthClassObj[header.value]"
            ></v-switch>
          </v-flex>

          <v-flex xs12>
            <span class="subheading">Cost/Sell</span>
            <v-divider class="mt-2"></v-divider>
          </v-flex>
          <v-flex
            xs12
            sm6
            v-for="(header) of allPossibleHeaders.filter(item =>{ return item.group == 'cost'})"
            :key="header.value"
            v-show="header.value != 'name'"
          >
            <v-switch
              :disabled="userAuthClassObj.id == 1"
              :label="header.text"
              v-model="userAuthClassObj[header.value]"
            ></v-switch>
          </v-flex>

          <v-flex xs12>
            <span class="subheading">Data Entry</span>
            <v-divider class="mt-2"></v-divider>
          </v-flex>
          <v-flex
            xs12
            sm6
            v-for="(header) of allPossibleHeaders.filter(item =>{ return item.group == 'dataEntry'})"
            :key="header.value"
            v-show="header.value != 'name'"
          >
            <v-switch
              :disabled="userAuthClassObj.id == 1"
              :label="header.text"
              v-model="userAuthClassObj[header.value]"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="primaryGrey" flat @click="close()">Cancel</v-btn>
        <v-btn
          :color="primaryNeutral"
          flat
          type="submit"
          :loading="loading"
        >{{add ? 'Add' : 'Edit'}}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserService from "@/services/requests/userService";
import UserAuthClassHeaders from "./userAuthClassHeaders";
import Api from "@/services/api";
export default {
  mixins: [UserAuthClassHeaders],
  data() {
    return {
      loading: false,
      userAuthClassObj: this.getUserAuthClass(),
      nameRules: []
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      try {
        if (this.add)
          var result = await Api.post(
            "user/userAuthClass",
            this.userAuthClassObj
          );
        else
          var result = await Api.put(
            `user/userAuthClass/${this.userAuthClassObj.id}`,
            this.userAuthClassObj
          );

        var string = "updated";
        if (this.add) string = "added";
        this.snack({
          text: `User Authorization Class was ${string}!`,
          color: "green"
        });
        this.$store.commit("users/setState", {
          prop: "fetchUserAuthClasses",
          value: true
        });
        this.close();
      } catch (err) {
        console.log(err);

        this.snack({ text: "An error occured!", color: "red" });
      }
    },
    resetForm() {
      if (this.add) this.userAuthClassObj = this.getUserAuthClass();
      this.$refs.form.resetValidation();
    },
    getUserAuthClass() {
      return {
        name: "",
        allocationRead: false,
        allocationWrite: false,
        docketRead: false,
        docketWrite: false,
        allowDocketEntry: false,
        rctiRead: false,
        rctiWrite: false,
        billingRead: false,
        billingWrite: false,
        userRead: false,
        userWrite: false,
        clientRead: false,
        clientWrite: false,
        rateRead: false,
        rateWrite: false,
        contractorRead: false,
        contractorWrite: false,
        tipRead: false,
        tipWrite: false,
        showCost: false,
        showSell: false,
        allocationStagingRead: false,
        allocationStagingWrite: false,
        allocationStagingEntry: false,
        tippingRead: false,
        tippingWrite: false,
        tippingEntry: false,
        complianceWrite: false,
        complianceRead: false,
        allowInductionEntry: false
      };
    },
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    if (!this.add) this.userAuthClassObj = Object.assign({}, this.item);
  },
  props: {
    add: Boolean,
    item: Object
  }
};
</script>

<style>
</style>
